<!--/**-->
<!--* 基础菜单 标签管理-->
<!--*/-->
<template>
    <div style="width: 100%; height: 100%;">

        <div style="margin: 10px 0px;">

            <el-col :span="12">
                <!--                @click="provinceVisible = true"-->
                <div class="grid-content bg-purple">
                    <van-icon name="location-o" style="margin: 10px 0px 10px 10px"/>
                    <span style="font-size: 14px;margin: 10px 0px 10px 0px">{{province}}</span>

                    <span style="font-size: 14px;margin: 10px 0px 10px 0px">挂网查询</span>
                </div>
                <!--                <div class="grid-content bg-purple"></div>-->
            </el-col>
            <el-col :span="12">
                <div class="grid-content bg-purple-light" style="text-align: right;">
                    <van-icon name="wap-home-o" style="margin: 10px 10px" @click="homePage"/>
                    <van-icon name="search" style="margin: 10px 10px" @click="dialogVisible = true"/>
                    <van-icon name="user-o" style="margin: 10px 10px" color="blue" @click="userPersonal"/>
                </div>
            </el-col>
        </div>
        <!--        #dddce7-->
        <el-table
                size="small" class="el-table" :data="listData" highlight-current-row v-loading="loading"
                element-loading-text="拼命加载中"
                :header-cell-style="{'background-color':'#fafafa','height':'30px','color':'#606266'}"
                height="95%" border style="width: 100%;"
                :row-class-name="rowClassName"
                v-el-table-infinite-scroll="loadMore" @row-click="handClick">
            <!--            <el-table-column  align="center" prop="xh" width="50" fixed></el-table-column>-->
            <el-table-column prop="genericName" label="通用名" fixed width="150">
                <template slot-scope="scope">
                    <!--                   <span v-if="scope.row.xh" style="text-align:center;height: 15px;width: 15px;border: 1px solid red;border-radius:50%">{{scope.row.xh}}</span>-->
                    <span>{{ scope.row.genericName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="specification" label="规格" width="200"></el-table-column>
            <el-table-column prop="conversionRatio" label="转换比" width="80"></el-table-column>
            <el-table-column prop="preparationUnit" label="最小制剂单位" width="100"></el-table-column>
            <el-table-column prop="productionEnterprise" label="生产企业" width="200"></el-table-column>
            <el-table-column prop="linkagePrice" label="联动参考价" width="120" sortable></el-table-column>
            <!--            <el-table-column prop="qualityLevel" label="质量层次" width="220"></el-table-column>-->
            <!--            <el-table-column prop="tradeName" label="商品名" width="100"></el-table-column>-->
            <el-table-column prop="healthType" label="医保类型" width="80"></el-table-column>
            <el-table-column prop="basicMedicine" label="是否基药" width="80"></el-table-column>
        </el-table>

        <van-popup

                v-model="dialogVisible"
                position="bottom"
                :style="{ height: '90%'}"
        >
            <van-form @submit="search">
                <van-cell-group>

                    <van-cell use-label-slot center title="数据类型"
                              @click="generic_nameSearch($event)" id="type"
                    >
                        <template slot="label">
                            <el-tag
                                    size="mini"
                                    type="success">
                                {{typeResult[type]}}
                            </el-tag>
                        </template>
                    </van-cell>
                    <van-cell use-label-slot center :title="item.title" :id="item.key"
                              @click="generic_nameSearch($event)" v-for="item in searchDataColumns" :key="item.key"
                    >
                        <template slot="label">
                            <template v-if="searchData[item.result].length != 0">
                                <el-tag
                                        v-for="tag in searchData[item.result]"
                                        :key="tag"
                                        size="mini"
                                        @close="childClick(tag,item.key)"
                                        closable
                                        type="success">
                                    {{tag}}
                                </el-tag>
                            </template>
                            <span v-else style="font-size: 12px;color: #969799">请选择</span>
                        </template>
                    </van-cell>

                </van-cell-group>
                <div style="height: 50px"></div>
                <div style="position: fixed;bottom: 0;width: 100%">
                    <van-button square block type="info" size="large">确定</van-button>
                </div>

            </van-form>

        </van-popup>


        <van-popup
                v-model="generic_nameVisible"
                position="bottom"
                :style="{ height: '60%' }"
        >
            <div>
                <van-search value="" placeholder="请输入搜索关键词" style="position: fixed;width: 100%"
                            v-model="searchInline.value"
                            show-action
                            v-if="searchType !== 'type'"
                            @input="searchByColumns">
                    <template #action>
                        <div @click="removeCheckbox" style="color: #a6a9ad">清除已选</div>
                    </template>
                </van-search>

                <div style="height: 54px" v-if="searchType !== 'type'"></div>
                <van-list
                        v-model:loading="loading"
                        :finished="searchInline.finished"
                        @load="searchColumns"
                >
                    <div style="padding: 0px 12px">

                        <van-checkbox-group v-model="checkBoxResult" ref="checkboxGroup" v-if="searchType !== 'type'">
                            <div class="van-checkbox-cell-group" v-for="(item,index) in datas" :key="index">
                                <van-checkbox :name="item.name" ref="checkbox" shape="square"
                                              style="border-bottom: 1px solid #ebedf0;">
                                    <van-cell style="padding: 5px 16px" center :title="item.value" :id="item.name"/>
                                </van-checkbox>
                            </div>
                        </van-checkbox-group>

                        <van-radio-group v-model="type" v-else>
                            <van-radio name="1" shape="square" style="border-bottom: 1px solid #ebedf0;">
                                <van-cell style="padding: 5px 16px" center title="挂网产品"/>
                            </van-radio>
                            <van-radio name="0" shape="square" style="border-bottom: 1px solid #ebedf0;">
                                <van-cell style="padding: 5px 16px" center title="未挂网"/>
                            </van-radio>
                            <van-radio name="2" shape="square" style="border-bottom: 1px solid #ebedf0;">
                                <van-cell style="padding: 5px 16px" center title="全部产品"/>
                            </van-radio>
                        </van-radio-group>


                    </div>
                    <div style="height: 50px"></div>
                    <div style="position: fixed;bottom: 0;width: 100%">
                        <van-button square block type="info" size="large" native-type="submit"
                                    @click="genericName()">确定
                        </van-button>
                    </div>
                </van-list>
            </div>
        </van-popup>
    </div>
</template>
<script>
    import Template from "../../components/template";

    export default {
        components: {Template}
    }
</script>
<script>
    import {list, getColumns} from '../../api/drug'
    import elTableInfiniteScroll from "el-table-infinite-scroll";
    import {Picker} from 'vant';
    import {Toast} from 'vant';

    export default {
        inject: ['reload'],
        data() {
            return {
                nshow: true, //switch开启
                fshow: false, //switch关闭
                loading: false, //是显示加载
                formInline: {
                    pageNum: 0,
                    pageSize: 20,
                    genericNames: [],
                    specifications: [],
                    productionEnterprises: [],
                    healthTypes: [],
                    qualityLevels: [],
                    basicMedicines: [],
                    countriesTalks: [],
                    token: localStorage.getItem('logintoken'),
                    finish: false
                },
                searchInline: {
                    pageNum: 0,
                    pageSize: 20,
                    name: '',
                    value: '',
                    token: localStorage.getItem('logintoken'),
                    finished: false
                },

                listData: [], //用户数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
                _height: null,
                // 表格高度
                tableHeight: 0,
                // 搜索框是否显示
                dialogVisible: false,
                generic_nameVisible: false,
                fullscreen: true,
                showclose: false,
                dialogHeight: '100%',
                provinceVisible: false,// 选择省份
                province: '四川',
                provinceId: '',
                columns: ['北京市', '上海市', '天津市', '重庆市', '黑龙江省', '吉林省', '辽宁省', '内蒙古', '河北省'],
                refreshing: false,
                datas: [],
                searchType: '',
                searchValue: '',
                checkBoxResult: [],
                searchDataColumns: [{
                    title: '通用名',
                    key: 'generic_name',
                    result: 'genericNameResult',
                }, {
                    title: '规格',
                    key: 'specification',
                    result: 'specificationResult',
                }, {
                    title: '生产企业',
                    key: 'production_enterprise',
                    result: 'productionEnterpriseResult',
                },
                    {
                        title: '医保类型',
                        key: 'health_type',
                        result: 'healthTypeResult',
                    },
                    {
                        title: '质量层次',
                        key: 'quality_level',
                        result: 'qualityLevelResult',
                    }, {
                        title: '国家基本药物',
                        key: 'basic_medicine',
                        result: 'basicMedicineResult',
                    },
                    {
                        title: '国家谈判药品',
                        key: 'countries_talk',
                        result: 'countriesTalkResult',
                    }],
                searchData: {
                    genericNameResult: [], // 名称
                    specificationResult: [], // 规格
                    productionEnterpriseResult: [], //生产企业
                    healthTypeResult: [], // 医保类型
                    qualityLevelResult: [], // 质量层次
                    basicMedicineResult: [], // 是否基药
                    countriesTalkResult: [], // 是否国谈
                },
                type: '1',
                typeResult: ['未挂网','挂网产品','全部产品' ]
            }
        },
        // 注册组件
        components: {
            "el-table-infinite-scroll": elTableInfiniteScroll
        },
        /**
         * 数据发生改变
         */

        /**
         * 创建完毕
         */
        created() {
            // let height= this.$refs.element.offsetHeight;  //100
            // const query = Qs.parse(location.search.substring(1))

            // let passport = query.passport;
            let Enterprise = this.$route.query.Enterprise;
            let name = this.$route.query.genericName;
            if (name) {
                this.formInline.genericNames.push(name)
                this.genericNameResult.push(name);
                this.genericNameResultLabel = this.genericNameResult.join(",");
            }
            if (Enterprise && Enterprise !== null) {
                this.formInline.productionEnterprises.push(Enterprise)
                this.productionEnterpriseResult.push(Enterprise)
                this.productionEnterpriseResultLabel = this.productionEnterpriseResult.join(",");
            }
            // let script = document.createElement('script');
            // script.setAttribute('async', '');
            // script.setAttribute('charset', 'utf-8');
            // script.setAttribute('type', 'text/javascript');
            // script.addEventListener('load', () => {
            //
            // });
            // script.addEventListener('error', () => {
            //     self.printError('Failed to load ');
            // });
            // script.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
            // let node = document.getElementsByTagName('script')[0];
            // node.parentNode.insertBefore(script, node);

            this._height = window.innerHeight;
            this.formInline.type = this.type
            this.getdata(this.formInline)


        },
        mounted() {


        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            childClick(tag, event) {
                this.searchDataColumns.forEach(item => {
                    if (item.key === event) {
                        this.searchData[item.result].splice(this.searchData[item.result].indexOf(tag), 1)
                    }
                })
            },
            rowClassName({row, rowIndex}) {
                let className = "";
                if (rowIndex % 2 == 0) {
                    className =  'warning-row';
                } else if (rowIndex % 2 == 1) {
                    className =  'success-row';
                }
                if (row.type == 0){
                    className = className + " type0";
                }
                return className;


            },
            // 获取公司列表
            getdata(parameter) {
                if (this.formInline.finish) {
                    return
                }

                parameter.pageNum = parameter.pageNum + 1;
                this.loading = true
                /***
                 * 调用接口，注释上面模拟数据 取消下面注释
                 */
                list(parameter)
                    .then(res => {
                        this.loading = false
                        console.log(res);
                        if (res.resultCode.code !== '00000') {
                            this.$message({
                                type: 'info',
                                message: res.resultCode.cnMsg
                            })
                        } else {
                            for (let i = 0; i < res.result.list.length; i++) {
                                let drug = res.result.list[i];
                                drug.genericName = this.strSub(drug.genericName, 10);
                                drug.productionEnterprise = this.strSub(drug.productionEnterprise, 14);
                                drug.specification = this.strSub(drug.specification, 15);
                            }
                            let tmpArr = this.listData;
                            tmpArr.push.apply(tmpArr, res.result.list);
                            this.listData = tmpArr
                            this.formInline.finish = !res.result.hasNextPage;
                        }
                    })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.pageNum = parm.currentPage
                this.formInline.pageSize = parm.pageSize
                this.getdata(this.formInline)
            },
            // 清缓存
            clearCache: function () {
                this.formInline.pageNum = 0;
                this.formInline.finish = false;
                this.listData = [];
            },
            // 搜索事件
            search() {
                // document.querySelector("input").blur();

                this.dialogVisible = false;
                window.scrollTo(0, 0)
                this.clearCache();
                this.formInline.genericNames = this.searchData.genericNameResult;
                this.formInline.specifications = this.searchData.specificationResult;
                this.formInline.productionEnterprises = this.searchData.productionEnterpriseResult;
                this.formInline.healthTypes = this.searchData.healthTypeResult;
                this.formInline.qualityLevels = this.searchData.qualityLevelResult;
                this.formInline.basicMedicines = this.searchData.basicMedicineResult;
                this.formInline.countriesTalks = this.searchData.countriesTalkResult;
                console.log(this.type,typeof(this.type))
                if (this.type  !== '2'){
                    this.formInline.type = this.type;
                }else{
                    this.formInline.type = null;
                }

                this.getdata(this.formInline)
            },

            // 删除
            deleteLabel(index, row) {
                this.$confirm('是否确定删除"' + row.label + '"', '删除提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                })
                    .then(() => {
                        deleteLabel({ids: [row.id]})
                            .then(res => {
                                if (res.resultCode.code !== '00000') {
                                    this.$message({
                                        type: 'info',
                                        message: res.resultCode.cnMsg
                                    })
                                } else {
                                    this.$message({
                                        type: 'success',
                                        message: '已删除!'
                                    })
                                    this.getdata(this.formInline)
                                }
                            })
                            .catch(err => {
                                this.loading = false
                                this.$message.error('删除失败，请稍后再试！')
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            strSub(str, len) {
                if (str){
                    if (str.length > len) {
                        str = str.slice(0, len) + '..';
                    }
                }
                return str;
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
            },
            getDrugInfo(id) {
                const {href} = this.$router.resolve({name: "药品详细"});
                localStorage.setItem("drugId", id)
                window.open(href, '_blank');
                // this.$router.push({name:'药品详细',params:{setid:111222}});
            },
            // 加载更多
            loadMore() {

                if (!this.loading) {
                    this.loading = true;
                    if (!this.formInline.finish) {
                        this.getdata(this.formInline);
                    } else {
                        // this.$message("已加载完所有的数据！");
                        this.loading = false;
                    }
                }
            },
            userPersonal(row) {

                wx.miniProgram.navigateTo({
                    url: '/pages/personal/favorites',
                    // url: '/pages/scenic/scenic_detail/scenic_detail?id='+id+'&title='+title

                })
            },
            handClick(row) {
                console.log(row)
                wx.miniProgram.navigateTo({
                    url: '/pages/drug/drugInfo?id=' + row.id
                })
            },
            showProvince() {

            },
            onChange(picker, value, index) {
                Toast(`当前值：${value}, 当前索引：${index}`);
            },
            generic_nameSearch(e) {
                this.loading = true;
                this.searchInline.value = "";
                let column = e.currentTarget.id;
                this.datas = [];
                this.searchType = column;
                this.searchInline.name = column;
                this.searchInline.pageNum = 0;

                if (column === "generic_name") {
                    this.checkBoxResult = this.searchData.genericNameResult;
                } else if (column === "specification") {
                    this.checkBoxResult = this.searchData.specificationResult;
                } else if (this.searchType === "production_enterprise") {
                    this.checkBoxResult = this.searchData.productionEnterpriseResult;
                } else if (this.searchType === "health_type") {
                    this.checkBoxResult = this.searchData.healthTypeResult;
                } else if (this.searchType === "quality_level") {
                    this.checkBoxResult = this.searchData.qualityLevelResult;
                } else if (this.searchType === "basic_medicine") {
                    this.checkBoxResult = this.searchData.basicMedicineResult;
                } else if (this.searchType === "countries_talk") {
                    this.checkBoxResult = this.searchData.countriesTalkResult;
                }
                this.generic_nameVisible = true;
                this.searchInline.finished = false;
                console.log(this.searchType)
                this.searchColumns(this.searchInline);
            },
            searchColumns() {
                if (this.searchInline.finished) {
                    return
                }

                this.searchInline.pageNum = this.searchInline.pageNum + 1;
                this.loading = true;
                getColumns(this.searchInline)
                    .then(res => {
                        this.loading = false
                        if (res.resultCode.code !== '00000') {
                            this.$message({
                                type: 'info',
                                message: res.resultCode.cnMsg
                            })
                        } else {
                            let tmpArr = this.datas;

                            for (let i = 0; i < res.result.list.length; i++) {
                                let name = res.result.list[i];
                                if (name === null) {
                                    res.result.list[i] = {'name': '未填写', value: '未填写'}
                                }
                            }

                            tmpArr.push.apply(tmpArr, res.result.list);
                            this.datas = tmpArr
                            this.searchInline.finished = !res.result.hasNextPage;
                        }
                    })
            },
            searchByColumns() {
                this.searchInline.finished = false;
                this.searchInline.pageNum = 0;
                this.datas = [];
                this.searchColumns();
            },

            onRefresh() {
                console.log('下拉');
                this.searchInline.finished = false;
                this.searchInline.pageNum = 0;
                this.datas = [];
                this.searchColumns();
            },
            genericName() {
                this.generic_nameVisible = false;

                if (this.searchType === "generic_name") {
                    this.searchData.genericNameResult = this.checkBoxResult;
                } else if (this.searchType === "specification") {
                    this.searchData.specificationResult = this.checkBoxResult;
                } else if (this.searchType === "production_enterprise") {
                    this.searchData.productionEnterpriseResult = this.checkBoxResult;
                } else if (this.searchType === "health_type") {
                    this.searchData.healthTypeResult = this.checkBoxResult;
                } else if (this.searchType === "quality_level") {
                    this.searchData.qualityLevelResult = this.checkBoxResult;
                } else if (this.searchType === "basic_medicine") {
                    this.searchData.basicMedicineResult = this.checkBoxResult;
                } else if (this.searchType === "countries_talk") {
                    this.searchData.countriesTalkResult = this.checkBoxResult;
                }
                this.checkBoxResult = [];


            },
            removeCheckbox(e) {

                this.checkBoxResult = []
            },
            homePage() {
                console.log('1111')
                this.reload();
            }

        }
    }
</script>


<style vars="dialogHeight">

    .el-table .type0{
        color: #8eb1f9;
    }
    .el-table .success-row {
        background: #f2f2f3;
        box-shadow: 5px 5px 10px #888888;
    }

    .el-form-item__content {
        width: 100%;
    }

    .el-dialog__body {
        /*height: 70%;*/
        height: calc(100vh - 200px);
    }

    .el-row {
        margin-bottom: 20px;
    }

    .el-col {
        border-radius: 4px;
    }

    .bg-purple-dark {
        background: #99a9bf;
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }

    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }

    .caret-wrapper {
        height: 30px;
    }

    .el-table thead {
        height: 40px;
    }

    .el-table .caret-wrapper {
        height: 34px;
    }

    .van-doc-demo-block__title {
        margin: 0;
        padding: 5px 5px;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }

    .mycheckbox {
        padding-bottom: 10px;
        padding-top: 10px;
        border-bottom: 1px solid #ededed;
    }

    /*.van-checkbox-group {*/
    /*    padding-bottom: 48px;*/


    /*}*/

    /*.van-checkbox-cell-group {*/
    /*    width: 100%;*/
    /*    height: 100%;*/
    /*    display: flex;*/
    /*    !*margin-bottom: 8px;*!*/
    /*    border-bottom: 1px solid #ebedf0;*/
    /*}*/

    /*.van-checkbox {*/
    /*    width: 30px;*/
    /*    background: #fff;*/
    /*}*/

    /*/deep/ .van-checkbox__label {*/
    /*    margin-left: 20px;*/
    /*    width: 100%;*/
    /*}*/

    /*/deep/ .van-checkbox__icon {*/
    /*    margin-left: 16px;*/
    /*}*/

    /deep/ .van-tag {
        margin-left: 8px;
    }

    .van-cell {
        position: static;
        padding: 5px 16px;
    }

    .van-icon {
        position: static;
    }
</style>






// WEBPACK FOOTER //
// src/views/applet/index.vue